import { connect } from "react-redux";
import Index from "../../components/Segment/List/Index";

import {
  getSegmentList,
  getSegmentArchiveData,
  getCreateCampaign,
  rollbackRequestSuccessToFalse,
  searchByName,
  getSegmentWithRules,
  archiveSegment,
  selectedSegment,
} from "../../actions/SegmentList";

import { selectClient } from "../../actions/App";
import { loadAttributes } from "../../actions/SegmentCreation";
import { fetchSegmentSummary } from "../../actions/SegmentDetail";

const mapStateToProps = state => {
  const {
    segment_archive_data,
    create_campaign,
    searchByNameResult,
    selectedSegmentSetArray,
    segment_list_active,
    recordActiveQueryParamsObj,
  } = state.segmentList;
  const { segment_summary } = state.segmentDetail;

  const { categories, value_typehead } = state.segmentCreation;
  const { selected_client } = state.app;
  const { roleId, clients, roleName, client_info } = state.app;
  return {
    // segment_list,
    segment_archive_data,
    create_campaign,
    selected_client,
    roleId,
    clients,
    client_info,
    roleName,
    searchByNameResult,
    selectedSegmentSetArray,
    segment_list_active,
    recordActiveQueryParamsObj,
    segment_summary,
    categories,
    value_typehead,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSegmentList: data => {
      dispatch(getSegmentList(data));
    },
    getSegmentArchiveData: data => {
      dispatch(getSegmentArchiveData(data));
    },
    getCreateCampaign: (id, data) => {
      dispatch(getCreateCampaign(id, data));
    },
    rollbackRequestSuccessToFalse: val => {
      dispatch(rollbackRequestSuccessToFalse(val));
    },
    searchByName: obj => {
      dispatch(searchByName(obj));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
    getSegmentWithRules: id => {
      dispatch(getSegmentWithRules(id));
    },
    archiveSegment: id => {
      dispatch(archiveSegment(id));
    },
    selectedSegment: setArray => {
      dispatch(selectedSegment(setArray));
    },
    loadAttributes: cid => {
      dispatch(loadAttributes(cid));
    },
    fetchSegmentSummary: id => {
      dispatch(fetchSegmentSummary(id));
    },
  };
};

const SegmentIndex = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Index);

export default SegmentIndex;



// WEBPACK FOOTER //
// ./src/containers/SegmentList/Index.js